import {useState, useEffect, useRef} from 'react';
import globalContext from './../../../src/config/context';
import Config from './../../../src/config/config';

import L from 'leaflet';
import proj4 from 'proj4';
import 'proj4leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-responsive-popup';
import 'leaflet-responsive-popup/leaflet.responsive.popup.css';

import Api from '../../config/api';
import swal from 'sweetalert';

import Chart from 'chart.js/auto';
import Numeral from 'numeral';

const useHook = () => {
  const {useAppContext} = globalContext;
  const [
    {pencarian, loading,
      checkedPbb,
      checkedBphtb,
      checkedHotel,
      checkedRestoran,
      checkedHiburan,
      checkedReklame,
      checkedPpj,
      checkedMblb,
      checkedParkir,
      checkedPat,
      checkedWalet,
      checkedPendataan, centroidLatitude, centroidLongitude, zoomKelurahan, zoomBlok, zoomPersil},
    {
      setPencarian,
      setLoading,
      setCheckedPbb,
      setCheckedBphtb,
      setCheckedHotel,
      setCheckedRestoran,
      setCheckedHiburan,
      setCheckedReklame,
      setCheckedPpj,
      setCheckedMblb,
      setCheckedParkir,
      setCheckedPat,
      setCheckedWalet,
      setCheckedPendataan,
      setCentroidLatitude,
      setCentroidLongitude,
      setZoomKelurahan,
      setZoomBlok,
      setZoomPersil,
    },
  ] = useAppContext();

  const mapRef = useRef();
  const [zoomLoading, setZoomLoading] = useState(1);
  const [currentBaseLayer, setCurrentBaseLayer] = useState(true);

  //Set Zoom------------------------------------------------------------------------------------------------------------
  // const [zoomKelurahan, setZoomKelurahan] = useState('');
  // const [zoomBlok, setZoomBlok] = useState('');
  // const [zoomPersil, setZoomPersil] = useState('');
  const getZoom = () => {
    // setLoading(true);
    Api.get('gis/settings/get_zoom')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setZoomKelurahan(response.data[0].kelurahan);
          setZoomBlok(response.data[0].blok);
          setZoomPersil(response.data[0].persil);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  //Kelurahan
  const [kelurahan, setKelurahan] = useState([]);
  const kelurahanRefGeoJson = useRef();
  //Blok
  const [blok, setBlok] = useState([]);
  const blokRefGeoJson = useRef();
  //Blok
  const [persil, setPersil] = useState([]);
  const persilRefGeoJson = useRef();
  //ZNT
  const [znt, setZnt] = useState([]);
  const zntRefGeoJson = useRef();
  //pendataan
  const [markerPendataan, setMarkerPendataan] = useState([]);
  const markerPendataanRefGeoJson = useRef();

  useEffect(() => {
    getZoom();
  }, []);

  useEffect(() => {
    getCentroid();
    getData();
  }, [currentBaseLayer]);

  //set Base Layer Change
  const baseLayerChange = (e) => {
    setCurrentBaseLayer(e.name === 'Open Street Maps' || e.name === 'Google Maps');
  };

  //set Zoom
  const zoomEnd = (e) => {
    getData();
  };

  //set CRS
  new L.Proj.CRS('EPSG:' + Config.GEOM_ESPG, Config.proj4def);

  //set Drag
  const dragEnd = (e) => {
    getData();
  };

  //Set Zoom GeoJson
  const getData = () => {
    const map = mapRef.current.leafletElement;
    const zoomLevel = map.getZoom();
    console.log(zoomLevel);
    // console.log('kelurahan', zoomKelurahan);
    // console.log('blok', zoomBlok);
    // console.log('persil', zoomPersil);

    if (zoomLevel <= zoomKelurahan) {
      //clear semua layer
      if (typeof blokRefGeoJson.current !== 'undefined') {
        if (blokRefGeoJson.current) {
          blokRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof persilRefGeoJson.current !== 'undefined') {
        if (persilRefGeoJson.current) {
          persilRefGeoJson.current.leafletElement.clearLayers();
          markerPbbRefGeoJson.current.leafletElement.clearLayers();
          markerBphtbRefGeoJson.current.leafletElement.clearLayers();
          markerHotelRefGeoJson.current.leafletElement.clearLayers();
          markerRestoranRefGeoJson.current.leafletElement.clearLayers();
          markerHiburanRefGeoJson.current.leafletElement.clearLayers();
          markerReklameRefGeoJson.current.leafletElement.clearLayers();
          markerPpjRefGeoJson.current.leafletElement.clearLayers();
          markerParkirRefGeoJson.current.leafletElement.clearLayers();
          markerPatRefGeoJson.current.leafletElement.clearLayers();
          markerWaletRefGeoJson.current.leafletElement.clearLayers();
          markerMblbRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof zntRefGeoJson.current !== 'undefined') {
        if (zntRefGeoJson.current) {
          zntRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof markerPendataanRefGeoJson.current !== 'undefined') {
        if (markerPendataanRefGeoJson.current) {
          markerPendataanRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      //get kelurahan
      getKelurahan();
    } else if (zoomLevel >= zoomBlok && zoomLevel < zoomPersil) {
      //clear semua layer
      if (typeof kelurahanRefGeoJson.current !== 'undefined') {
        if (kelurahanRefGeoJson.current) {
          kelurahanRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof persilRefGeoJson.current !== 'undefined') {
        if (persilRefGeoJson.current) {
          persilRefGeoJson.current.leafletElement.clearLayers();
          markerPbbRefGeoJson.current.leafletElement.clearLayers();
          markerBphtbRefGeoJson.current.leafletElement.clearLayers();
          markerHotelRefGeoJson.current.leafletElement.clearLayers();
          markerRestoranRefGeoJson.current.leafletElement.clearLayers();
          markerHiburanRefGeoJson.current.leafletElement.clearLayers();
          markerReklameRefGeoJson.current.leafletElement.clearLayers();
          markerPpjRefGeoJson.current.leafletElement.clearLayers();
          markerParkirRefGeoJson.current.leafletElement.clearLayers();
          markerPatRefGeoJson.current.leafletElement.clearLayers();
          markerWaletRefGeoJson.current.leafletElement.clearLayers();
          markerMblbRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof markerPendataanRefGeoJson.current !== 'undefined') {
        if (markerPendataanRefGeoJson.current) {
          markerPendataanRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof blokRefGeoJson.current !== 'undefined') {
        if (blokRefGeoJson.current) {
          //get Blok
          getBlok(pencarian);
        }
      }
      if (typeof zntRefGeoJson.current !== 'undefined') {
        if (zntRefGeoJson.current) {
          //get ZNT
          getZnt(pencarian);
        }
      }
    } else if (zoomLevel >= zoomPersil) {
      //clear semua layer
      if (typeof kelurahanRefGeoJson.current !== 'undefined') {
        if (kelurahanRefGeoJson.current) {
          kelurahanRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof blokRefGeoJson.current !== 'undefined') {
        if (blokRefGeoJson.current) {
          blokRefGeoJson.current.leafletElement.clearLayers();
        }
      }
      if (typeof persilRefGeoJson.current !== 'undefined') {
        if (persilRefGeoJson.current) {
          // get Persil
          getPersil(pencarian);

          // get marker
          if (checkedPbb) {
            getMarkerPbb();
          }
          if (checkedBphtb) {
            getMarkerBphtb();
          }
          if (checkedHotel) {
            getMarkerHotel();
          }
          if (checkedRestoran) {
            getMarkerRestoran();
          }
          if (checkedHiburan) {
            getMarkerHiburan();
          }
          if (checkedReklame) {
            getMarkerReklame();
          }
          if (checkedPpj) {
            getMarkerPpj();
          }
          if (checkedParkir) {
            getMarkerParkir();
          }
          if (checkedPat) {
            getMarkerPat();
          }
          if (checkedWalet) {
            getMarkerWalet();
          }
          if (checkedMblb) {
            getMarkerMblb();
          }
        }
      }
      if (checkedPendataan === true) {
        if (typeof markerPendataanRefGeoJson.current !== 'undefined') {
          if (markerPendataanRefGeoJson.current) {
            getMarkerPendataan();
          }
        }
      }
    }
  };

  //GeoJson Kelurahan-------------------------------------------------------------------------------------------------
  const getKelurahan = () => {
    // const map = mapRef.current.leafletElement;

    if (zoomLoading !== 1) {
      setLoading(true);
      setZoomLoading(1);
    }
    Api.get('gis/geojson/kelurahan')
      .then(function (response) {
        if (response) {
          setKelurahan(response.data);

          if (typeof kelurahanRefGeoJson.current !== 'undefined') {
            if (kelurahanRefGeoJson.current) {
              kelurahanRefGeoJson.current.leafletElement.clearLayers();
              L.Proj.geoJson(response.data, {
                style: kelurahanStyle,
                onEachFeature: kelurahanOnEachFeature,
              }).addTo(kelurahanRefGeoJson.current.leafletElement);
            }
          }
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  //details Monografi Kelurahn
  const [monografiKelurahan, setMonografiKelurahan] = useState(false);
  const [detailMonografiKelurahan, setDetailMonografiKelurahan] = useState({});
  const [chartMonografiKelurahan, setChartMonografiKelurahan] = useState([]);
  const handleMonografiKelurahan = () => {
    setMonografiKelurahan((prev) => !prev);
  };

  const kelurahanStyle = (feature) => {
    // console.log(currentBaseLayer);
    if (feature) {
      return {
        color: currentBaseLayer ? '#363739' : '#fafafa',
        weight: 1.3,
        fillOpacity: currentBaseLayer ? 0.5 : 0.3,
        fillColor: feature.properties.WARNA,
      };
    }
  };

  const kelurahanOnEachFeature = (feature, layer) => {
    // console.log(feature)

    //---Popup
    // const popupContent = `${feature.properties.NM_KEL}`;
    // layer.bindPopup(popupContent);

    //---label
    // layer.bindTooltip(feature.properties.NM_KEL, {
    //   permanent: true,
    //   direction: 'center',
    //   className: classes.labelKelurahan,
    // });

    //---Hover
    layer.on({
      mouseover: kelurahanHighlightFeature,
      mouseout: kelurahanResetHighlight,
      click: kelurahanZoomToFeature,
    });
  };

  const kelurahanHighlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#fafafa' : '#363739',
      weight: 3,
      dashArray: '',
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });

    //---Layer Popup Hover
    // layer.openPopup();

    layer.bringToFront();
  };

  const kelurahanResetHighlight = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#363739' : '#fafafa',
      weight: 1.3,
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });

    //---Layer Popup Mouseover
    // layer.closePopup();
  };

  const kelurahanZoomToFeature = (e) => {
    setMonografiKelurahan((prev) => !prev);

    const kec = e.sourceTarget.feature.properties.KD_KECAMATAN;
    const kel = e.sourceTarget.feature.properties.KD_KELURAHAN;

    Api.get('gis/detail/detail_kelurahan', {
      kec,
      kel,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setDetailMonografiKelurahan(response.data);
        }
      }
    });

    Api.get('gis/chart/monografi_kelurahan', {
      kec,
      kel,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setChartMonografiKelurahan(response.data);
        }
      }
    });

    // const map = mapRef.current.leafletElement;
    // map.fitBounds(e.target.getBounds());
  };

  //GeoJson Blok------------------------------------------------------------------------------------------------------
  const getBlok = (set) => {
    // const map = mapRef.current.leafletElement;

    if (zoomLoading !== 2) {
      setLoading(true);
      setZoomLoading(2);
    }
    Api.get('gis/geojson/blok', {
      //pencarian
      current_kelurahan: set.kelurahan,
      current_blok: set.blok,
    })
      .then(function (response) {
        if (response) {
          setBlok(response.data);
          // console.log(response.data);
          // blokRefGeoJson.current.leafletElement.clearLayers().addData(response.data);

          if (typeof blokRefGeoJson.current !== 'undefined') {
            if (blokRefGeoJson.current) {
              blokRefGeoJson.current.leafletElement.clearLayers();
              L.Proj.geoJson(response.data, {
                style: blokStyle,
                onEachFeature: blokOnEachFeature,
              }).addTo(blokRefGeoJson.current.leafletElement);
            }
          }
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const blokStyle = (feature) => {
    // console.log(currentBaseLayer);
    if (feature) {
      return {
        color: currentBaseLayer ? '#1f2021' : '#fafafa',
        weight: 1.3,
        fillOpacity: currentBaseLayer ? 0.5 : 0.3,
        fillColor: feature.properties.WARNA,
      };
    }
  };

  const blokOnEachFeature = (feature, layer) => {
    // console.log(feature)

    //---label
    layer.bindTooltip(feature.properties.KD_BLOK, {
      permanent: true,
      direction: 'center',
      className: 'label-blok',
    });

    //---Hover
    layer.on({
      mouseover: blokHighlightFeature,
      mouseout: blokResetHighlight,
      click: blokZoomToFeature,
    });
  };

  const blokHighlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#fafafa' : '#1f2021',
      weight: 3,
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });

    layer.bringToFront();
  };

  const blokResetHighlight = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#1f2021' : '#fafafa',
      weight: 1.3,
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });
  };

  const blokZoomToFeature = (e) => {
    const map = mapRef.current.leafletElement;
    map.fitBounds(e.target.getBounds());
  };

  //GeoJson Persil------------------------------------------------------------------------------------------------------
  const getPersil = (set) => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);

    if (zoomLoading !== 3) {
      setLoading(true);
      setZoomLoading(3);
    }

    Api.get('gis/geojson/persil', {
      current_state: set.state,
      current_tahun: set.tahun,
      //pencarian
      current_nop: set.nop,
      current_kecamatan: set.kecamatan,
      current_kelurahan: set.kelurahan,
      current_blok: set.blok,

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setPersil(response.data);
          // console.log(response.data);
          // persilRefGeoJson.current.leafletElement
          //   .clearLayers()
          //   .addData(response.data);

          if (typeof persilRefGeoJson.current !== 'undefined') {
            if (persilRefGeoJson.current) {
              persilRefGeoJson.current.leafletElement.clearLayers();
              L.Proj.geoJson(response.data, {
                style: persilStyle,
                onEachFeature: checkedPendataan === true ? null : persilOnEachFeature,
              }).addTo(persilRefGeoJson.current.leafletElement);
            }
          }

          // if (fused) {
          //   if (response.data.fused) {
          //     // console.log(response.data.fused.lat);
          //     const lat = response.data.fused.lat;
          //     // console.log(response.data.fused.long);
          //     const long = response.data.fused.long;
          //     map.panTo(new L.LatLng(lat, long));
          //   }
          // }
          // console.log(fused);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const persilStyle = (feature) => {
    // console.log(feature);
    if (feature) {
      return {
        color: currentBaseLayer ? '#1f2021' : '#fafafa',
        weight: 1.3,
        fillOpacity: feature.properties.WARNA ? (currentBaseLayer ? 0.5 : 0.3) : 0,
        fillColor: inputNop === feature.properties.NOP ? '#000000' : feature.properties.WARNA,
      };
    }
  };

  const persilOnEachFeature = (feature, layer) => {
    // console.log(feature)

    //---Popup
    if (feature.properties.NOP) {
      onDetails(feature, layer);
    }

    //---Hover
    layer.on({
      mouseover: persilHighlightFeature,
      mouseout: persilResetHighlight,
      // click: persilZoomToFeature,
    });
  };

  const persilHighlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#fafafa' : '#1f2021',
      weight: 3,
      fillOpacity: layer.feature.properties.WARNA ? (currentBaseLayer ? 0.5 : 0.3) : 0,
    });
    //---Layer Popup Hover
    layer.openPopup();
    //---?
    layer.bringToFront();
  };

  const persilResetHighlight = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#1f2021' : '#fafafa',
      weight: 1.3,
      fillOpacity: layer.feature.properties.WARNA ? (currentBaseLayer ? 0.5 : 0.3) : 0,
    });

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  // const persilZoomToFeature = (e) => {
  //   const map = mapRef.current.leafletElement;
  //   map.fitBounds(e.target.getBounds());
  // };

  const onDetails = (feature, layer) => {
    const popupContent = L.responsivePopup().setContent('<h4>NOP : <br /></h4><p>' + feature.properties.NOP + '</p>');
    layer.bindPopup(popupContent);

    layer.on('click', function (e) {
      const map = mapRef.current.leafletElement;
      map.fitBounds(e.target.getBounds());
      setInputNop(feature.properties.NOP);
    });
  };

  //GeoJson ZNT------------------------------------------------------------------------------------------------------
  const getZnt = (set) => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    if (zoomLoading !== 2) {
      setLoading(true);
      setZoomLoading(2);
    }

    Api.get('gis/geojson/znt', {
      current_state: set.state,
      current_tahun: set.tahun,

      //pencarian
      current_kecamatan: set.kecamatan,
      current_kelurahan: set.kelurahan,
    })
      .then(function (response) {
        if (response) {
          setZnt(response.data);
          // console.log(response.data);
          // zntRefGeoJson.current.leafletElement.clearLayers().addData(response.data);

          if (typeof zntRefGeoJson.current !== 'undefined') {
            if (zntRefGeoJson.current) {
              zntRefGeoJson.current.leafletElement.clearLayers();
              L.Proj.geoJson(response.data, {
                style: zntStyle,
                onEachFeature: zntOnEachFeature,
              }).addTo(zntRefGeoJson.current.leafletElement);
            }
          }
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const zntStyle = (feature) => {
    // console.log(currentBaseLayer);
    if (feature) {
      return {
        color: currentBaseLayer ? '#1f2021' : '#fafafa',
        weight: 1.3,
        fillOpacity: currentBaseLayer ? 0.5 : 0.3,
        fillColor: feature.properties.WARNA,
      };
    }
  };

  const zntOnEachFeature = (feature, layer) => {
    // console.log(feature)

    //---label
    layer.bindTooltip(feature.properties.KD_ZNT, {
      permanent: true,
      direction: 'center',
      className: 'label-znt',
    });

    //---Hover
    layer.on({
      mouseover: zntHighlightFeature,
      mouseout: zntResetHighlight,
      click: zntZoomToFeature,
    });
  };

  const zntHighlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#fafafa' : '#1f2021',
      weight: 3,
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });

    layer.bringToFront();
  };

  const zntResetHighlight = (e) => {
    const layer = e.target;
    layer.setStyle({
      color: currentBaseLayer ? '#1f2021' : '#fafafa',
      weight: 1.3,
      fillOpacity: currentBaseLayer ? 0.5 : 0.3,
    });
  };

  const zntZoomToFeature = (e) => {
    const map = mapRef.current.leafletElement;
    map.fitBounds(e.target.getBounds());
  };

  //Set Marker  PBB----------------------------------------------------------------------------------------------------------
  const [markerPbb, setMarkerPbb] = useState([]);
  const markerPbbRefGeoJson = useRef();
  const getMarkerPbb = (set) => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/pbb', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerPbb(response.data);
          markerPbbRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: PbbOnEachFeature,
            pointToLayer: PbbPointToLayer,
          }).addTo(markerPbbRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const PbbStyle = (feature) => {};

  const PbbPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/pbb.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const PbbOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOP}</b></div>    
              <div>${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: PbbMouserOver,
      mouseout: PbbMouseOut,
    });
  };

  const PbbMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const PbbMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker BPHTB----------------------------------------------------------------------------------------------------------
  const [markerBphtb, setMarkerBphtb] = useState([]);
  const markerBphtbRefGeoJson = useRef();

  const getMarkerBphtb = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/bphtb', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerBphtb(response.data);
          markerBphtbRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: bphtbOnEachFeature,
            pointToLayer: bphtbPointToLayer,
          }).addTo(markerBphtbRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const bphtbStyle = (feature) => {};

  const bphtbPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/bphtb' + feature.properties.RANGE + '.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const bphtbOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOP}</b></div>    
              <div>Tahun : ${feature.properties.THN_PAJAK}</div>    
              <div>Luas Bumi : ${formatNumber(feature.properties.OBJEK_LUAS_BUMI)}</div>    
              <div>NJOP Bumi / Meter : Rp.${formatNumber(feature.properties.OBJEK_NJOP_BUMI_PERMETER)}</div>    
              <div>NJOP Bumi M2 : Rp.${formatNumber(feature.properties.OBJEK_NJOP_BUMI_M2)}</div>    
              <div>Luas Bangunan : ${formatNumber(feature.properties.OBJEK_LUAS_BNG)}</div>    
              <div>NJOP Bangunan / Meter : Rp.${formatNumber(feature.properties.OBJEK_NJOP_BNG_PERMETER)}</div>    
              <div>NJOP Bangunan M2: Rp.${formatNumber(feature.properties.OBJEK_NJOP_BNG_M2)}</div>    
              <div>Total NJOP: Rp.${formatNumber(feature.properties.OBJEK_TOTAL_NJOP)}</div>    
              <div>Jumlah Yang Harus Dibayar: Rp.${formatNumber(feature.properties.JML_YG_HARUS_DIBAYAR)}</div>    
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: bphtbMouserOver,
      mouseout: bphtbMouseOut,
    });
  };

  const bphtbMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const bphtbMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Hotel----------------------------------------------------------------------------------------------------------
  const [markerHotel, setMarkerHotel] = useState([]);
  const markerHotelRefGeoJson = useRef();

  const getMarkerHotel = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/hotel', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerHotel(response.data);
          markerHotelRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: HotelOnEachFeature,
            pointToLayer: HotelPointToLayer,
          }).addTo(markerHotelRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const HotelStyle = (feature) => {};

  const HotelPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/hotel.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const HotelOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: HotelMouserOver,
      mouseout: HotelMouseOut,
    });
  };

  const HotelMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const HotelMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Restoran----------------------------------------------------------------------------------------------------------
  const [markerRestoran, setMarkerRestoran] = useState([]);
  const markerRestoranRefGeoJson = useRef();

  const getMarkerRestoran = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/restoran', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerRestoran(response.data);
          markerRestoranRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: RestoranOnEachFeature,
            pointToLayer: RestoranPointToLayer,
          }).addTo(markerRestoranRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const RestoranStyle = (feature) => {};

  const RestoranPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/restoran.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const RestoranOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: RestoranMouserOver,
      mouseout: RestoranMouseOut,
    });
  };

  const RestoranMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const RestoranMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Hiburan----------------------------------------------------------------------------------------------------------
  const [markerHiburan, setMarkerHiburan] = useState([]);
  const markerHiburanRefGeoJson = useRef();

  const getMarkerHiburan = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/hiburan', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerHiburan(response.data);
          markerHiburanRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: HiburanOnEachFeature,
            pointToLayer: HiburanPointToLayer,
          }).addTo(markerHiburanRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const HiburanStyle = (feature) => {};

  const HiburanPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/hiburan.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const HiburanOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: HiburanMouserOver,
      mouseout: HiburanMouseOut,
    });
  };

  const HiburanMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const HiburanMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Reklame----------------------------------------------------------------------------------------------------------
  const [markerReklame, setMarkerReklame] = useState([]);
  const markerReklameRefGeoJson = useRef();

  const getMarkerReklame = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/reklame', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerReklame(response.data);
          markerReklameRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: ReklameOnEachFeature,
            pointToLayer: ReklamePointToLayer,
          }).addTo(markerReklameRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const ReklameStyle = (feature) => {};

  const ReklamePointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/reklame.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const ReklameOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: ReklameMouserOver,
      mouseout: ReklameMouseOut,
    });
  };

  const ReklameMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const ReklameMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Ppj----------------------------------------------------------------------------------------------------------
  const [markerPpj, setMarkerPpj] = useState([]);
  const markerPpjRefGeoJson = useRef();

  const getMarkerPpj = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/ppj', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerPpj(response.data);
          markerPpjRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: PpjOnEachFeature,
            pointToLayer: PpjPointToLayer,
          }).addTo(markerPpjRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const PpjStyle = (feature) => {};

  const PpjPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/ppj.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const PpjOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: PpjMouserOver,
      mouseout: PpjMouseOut,
    });
  };

  const PpjMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const PpjMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Parkir----------------------------------------------------------------------------------------------------------
  const [markerParkir, setMarkerParkir] = useState([]);
  const markerParkirRefGeoJson = useRef();

  const getMarkerParkir = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/parkir', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerParkir(response.data);
          markerParkirRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: ParkirOnEachFeature,
            pointToLayer: ParkirPointToLayer,
          }).addTo(markerParkirRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const ParkirStyle = (feature) => {};

  const ParkirPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/parkir.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const ParkirOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: ParkirMouserOver,
      mouseout: ParkirMouseOut,
    });
  };

  const ParkirMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const ParkirMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Pat----------------------------------------------------------------------------------------------------------
  const [markerPat, setMarkerPat] = useState([]);
  const markerPatRefGeoJson = useRef();

  const getMarkerPat = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/pat', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerPat(response.data);
          markerPatRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: PatOnEachFeature,
            pointToLayer: PatPointToLayer,
          }).addTo(markerPatRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const PatStyle = (feature) => {};

  const PatPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/pat.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const PatOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: PatMouserOver,
      mouseout: PatMouseOut,
    });
  };

  const PatMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const PatMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Walet----------------------------------------------------------------------------------------------------------
  const [markerWalet, setMarkerWalet] = useState([]);
  const markerWaletRefGeoJson = useRef();

  const getMarkerWalet = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/walet', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerWalet(response.data);
          markerWaletRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: WaletOnEachFeature,
            pointToLayer: WaletPointToLayer,
          }).addTo(markerWaletRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const WaletStyle = (feature) => {};

  const WaletPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/walet.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const WaletOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: WaletMouserOver,
      mouseout: WaletMouseOut,
    });
  };

  const WaletMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const WaletMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker  Mblb----------------------------------------------------------------------------------------------------------
  const [markerMblb, setMarkerMblb] = useState([]);
  const markerMblbRefGeoJson = useRef();

  const getMarkerMblb = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    //kiri atas
    const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

    //kanan atas
    const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

    //kiri bawah
    const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

    //kanan bawah
    const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);


    Api.get('gis/marker/mblb', {

      //kiri atas
      northWestLat: Number(northWest[1]),
      northWestLng: Number(northWest[0]),

      //kanan atas
      northEastLat: Number(northEast[1]),
      northEastLng: Number(northEast[0]),

      //kiri bawah
      southWestLat: Number(southWest[1]),
      southWestLng: Number(southWest[0]),

      //kanan bawah
      southEastLat: Number(southEast[1]),
      southEastLng: Number(southEast[0]),
    })
      .then(function (response) {
        if (response) {
          setMarkerMblb(response.data);
          markerMblbRefGeoJson.current.leafletElement.clearLayers();
          L.Proj.geoJson(response.data, {
            onEachFeature: MblbOnEachFeature,
            pointToLayer: MblbPointToLayer,
          }).addTo(markerMblbRefGeoJson.current.leafletElement);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const MblbStyle = (feature) => {};

  const MblbPointToLayer = (feature, latlng) => {
    const myIcon = L.icon({
      iconUrl: require('../../assets/img/markers/mblb.png'),
      iconSize: [38, 'auto'],
      iconAnchor: [15, 50],
      popupAnchor: [2, -50],
      shadowSize: [68, 95],
      shadowAnchor: [22, 94],
    });

    return L.marker(latlng, {
      // return L.circleMarker(latlng, {
      icon: myIcon,
      opacity: 1,
    });
  };

  const MblbOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div><b>${feature.properties.NOPD_SHOW}</b></div>    
              <div>Nama Objek : ${feature.properties.NM_OBJEK}</div>    
              <div>Alamat Objek : ${feature.properties.ALAMAT}</div> 
            </div>
            `;
    layer.bindPopup(popupContent);

    //---Hover
    layer.on({
      mouseover: MblbMouserOver,
      mouseout: MblbMouseOut,
    });
  };

  const MblbMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const MblbMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Set Marker Pendataan----------------------------------------------------------------------------------------------------------
  const getMarkerPendataan = () => {
    const map = mapRef.current.leafletElement;
    const bounds = map.getBounds();

    if (map.getZoom() >= zoomPersil + 1) {
      //kiri atas
      const northWest = proj4(Config.proj4def, [bounds.getNorthWest().lng - 0.001, bounds.getNorthWest().lat + 0.001]);

      //kanan atas
      const northEast = proj4(Config.proj4def, [bounds.getNorthEast().lng + 0.001, bounds.getNorthEast().lat + 0.001]);

      //kiri bawah
      const southWest = proj4(Config.proj4def, [bounds.getSouthWest().lng - 0.001, bounds.getSouthWest().lat - 0.001]);

      //kanan bawah
      const southEast = proj4(Config.proj4def, [bounds.getSouthEast().lng + 0.001, bounds.getSouthEast().lat - 0.001]);

      Api.get('gis/marker/pendataan', {
        //kiri atas
        northWestLat: Number(northWest[1]),
        northWestLng: Number(northWest[0]),

        //kanan atas
        northEastLat: Number(northEast[1]),
        northEastLng: Number(northEast[0]),

        //kiri bawah
        southWestLat: Number(southWest[1]),
        southWestLng: Number(southWest[0]),

        //kanan bawah
        southEastLat: Number(southEast[1]),
        southEastLng: Number(southEast[0]),
      })
        .then(function (response) {
          if (response) {
            setMarkerPendataan(response.data);
            if (typeof markerPendataanRefGeoJson.current !== 'undefined') {
              if (markerPendataanRefGeoJson.current) {
                markerPendataanRefGeoJson.current.leafletElement.clearLayers();
                L.Proj.geoJson(response.data, {
                  onEachFeature: pendataanOnEachFeature,
                  pointToLayer: pendataanPointToLayer,
                }).addTo(markerPendataanRefGeoJson.current.leafletElement);
              }
            }
          }
        })
        .finally(function () {
          setLoading(false);
        });
    } else {
      markerPendataanRefGeoJson.current.leafletElement.clearLayers();
      setLoading(false);
    }
  };

  const pendataanStyle = (feature) => {};

  const pendataanPointToLayer = (feature, latlng) => {
    // const myIcon = L.icon({
    //   iconUrl: require('../../assets/img/markers/marker' + feature.properties.KD_PELAYANAN + '.png'),
    //   iconSize: [38, 'auto'],
    //   iconAnchor: [15, 50],
    //   popupAnchor: [2, -50],
    //   shadowSize: [68, 95],
    //   shadowAnchor: [22, 94],
    // });

    // return L.marker(latlng, {
    // icon: myIcon,
    // fillOpacity: 1,

    return L.circleMarker(latlng, {
      color: feature.properties.WARNA,
      fillColor: '#000',
      fillOpacity: 0.5,
      radius: 5,
    });
  };

  const pendataanOnEachFeature = (feature, layer) => {
    // console.log(feature)
    const formatNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
    }).format;
    //---Popup
    const popupContent = `
            <div>
              <div>${feature.properties.NOP}</div>   
              <div>Alamat OP :  ${feature.properties.JALAN_OP}, RT:${feature.properties.RT_OP} / RW:${feature.properties.RW_OP}</div>   
              <div>Luas Bumi :  ${feature.properties.TOTAL_LUAS_BUMI}</div>   
              <div>Luas Bangunan :  ${feature.properties.TOTAL_LUAS_BNG}</div>   
              <div>Kode ZNT :  ${feature.properties.KD_ZNT}</div>   
              <div>Wajib Pajak :  ${feature.properties.NAMA_WP}</div>   
              <div>Alamat WP :  ${feature.properties.JALAN_WP}, RT:${feature.properties.RT_WP} / RW:${feature.properties.RW_WP}</div>
              <div>Kecamatan :  ${feature.properties.KECAMATAN}</div>   
              <div>Kelurahan :  ${feature.properties.KELURAHAN}</div>                 
              <img src="${feature.properties.FOTO[0]}" width="215px" />                 
            </div>
            `;
    layer.bindPopup(popupContent).openPopup();

    //---Hover
    // layer.on({
    //   mouseover: pendataanMouserOver,
    //   mouseout: pendataanMouseOut,
    // });
  };

  const pendataanMouserOver = (e) => {
    const layer = e.target;

    //---Layer Popup Hover
    layer.openPopup();
  };

  const pendataanMouseOut = (e) => {
    const layer = e.target;

    //---Layer Popup Mouseover
    layer.closePopup();
  };

  //Pencarian-----------------------------------------------------------------------------------------------------------
  //set Facebook Progress
  const [facebookProgress, setFacebookProgress] = useState(false);

  //set Clear Icon
  const [clearIcon, setClearIcon] = useState(false);

  //details checked
  const [checked, setChecked] = useState(false);
  const handleDetails = () => {
    setChecked((prev) => !prev);
  };

  //details info
  const [inputNop, setInputNop] = useState('');
  const [piutangLoading, setPiutangLoading] = useState(false);
  const [searchNop, setSearchNop] = useState([]);
  const [searchSppt, setSearchSppt] = useState([]);
  const [detailNop, setDetailNop] = useState([]);
  const [detailSppt, setDetailSppt] = useState([]);
  const [images, setImages] = useState('');
  const [lat, setLat] = useState([]);
  const [long, setLong] = useState([]);

  const handleKeyPress = (event) => {
    // console.log(event.keyCode);
    if (event.keyCode === 13) {
      // console.log('enter press here! ');
      setInputNop(inputNop);
    }
  };

  const onClear = () => {
    const map = mapRef.current.leafletElement;
    setClearIcon(false);
    setChecked(false);
    setInputNop('');
    setPiutangLoading(false);
    setSearchNop([]);
    setSearchSppt([]);
    setDetailNop([]);
    setDetailSppt([]);
    setImages('');
    setLat([]);
    setLong([]);
    const tmp = {
      ...pencarian,
      nop: '',
    };
    setPencarian(tmp);
  };

  useEffect(() => {
    const nop = inputNop.replace(/[^\d]/g, '');
    if (inputNop && inputNop !== '' && nop.length === 18) {
      onSearchNop(inputNop);
    }
    if (!inputNop || inputNop === '') {
      const map = mapRef.current.leafletElement;
      if (map.getZoom() >= zoomPersil) {
        const tmp = {
          ...pencarian,
          nop: '',
        };
        setPencarian(tmp);
        setLoading(true);
        getPersil(tmp);
      }
    }
  }, [inputNop]);

  //Search NOP---------------------------------------------------------------------------------------------------
  const onSearchNop = (nop = null) => {
    const map = mapRef.current.leafletElement;
    setChecked(false);
    setClearIcon(false);
    setFacebookProgress(true);
    let input = nop ? nop : inputNop;

    if (input) {
      Api.get('gis/detail/search_nop', {
        nop: input,
      })
        .then(function (response) {
          if (response) {
            if (response.data) {
              const tmp = {
                ...pencarian,
                nop: input,
              };
              setPencarian(tmp);

              setSearchNop(response.data.op);
              setImages(response.data.images);
              setLat(response.data.op.latitude);
              setLong(response.data.op.longitude);

              map.panTo(new L.LatLng(response.data.op.latitude, response.data.op.longitude));
              setZoomLoading(3);
              if (map.getZoom() >= zoomPersil) {
                setTimeout(() => {
                  getPersil(tmp);
                }, 500);
              } else {
                setTimeout(() => {
                  map.setZoom(17);
                }, 500);
              }

              setChecked(true);
            }
          }
        })
        .finally(function () {
          onSearchSppt(input);
          onDetailNop(input);
          setFacebookProgress(false);
          setClearIcon(true);
        });
    } else {
      setFacebookProgress(false);
      swal({
        title: 'Masukkan NOP',
        text: null,
        icon: 'error',
        button: 'close',
      });
    }
  };

  const streetView = 'http://maps.google.com/maps?q=&layer=c&cbll=' + lat + ',' + long;

  const onSearchSppt = (nop) => {
    setSearchSppt([]);
    setPiutangLoading(true);
    Api.get('gis/detail/search_sppt', {
      nop,
    })
      .then(function (response) {
        if (response) {
          if (response.data) {
            setSearchSppt(response.data);
          }
        }
      })
      .finally(() => setPiutangLoading(false));
  };

  //Detail NOP---------------------------------------------------------------------------------------------------
  const onDetailNop = (nop) => {
    setDetailNop([]);
    Api.get('gis/detail/detail_nop', {
      nop,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setDetailNop(response.data);
        }
      }
    });
  };

  const [tahunSPPT, setTahunSPPT] = useState('2021');
  const handleTahunSPPT = (event) => {
    setTahunSPPT(event.target.value);
  };
  const [itemTahunSPPT, setItemTahunSPPT] = useState([]);
  useEffect(() => {
    // const onTahunSPPT = (nop) => {
    setItemTahunSPPT([]);
    Api.get('gis/detail/detail_tahun_sppt', {
      nop: inputNop,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setItemTahunSPPT(response.data);
        }
      }
    });
    // };
  }, [inputNop]);

  useEffect(() => {
    // const onSearchSppt = (nop) => {
    setDetailSppt([]);
    Api.get('gis/detail/detail_sppt', {
      nop: inputNop,
      tahun: tahunSPPT,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setDetailSppt(response.data);
        }
      }
    });
    // };
  }, [inputNop, tahunSPPT]);

  //Centroid-----------------------------------------------------------------------------------------------------------
  // const [centroidLatitude, setCentroidLatitude] = useState('');
  // const [centroidLongitude, setCentroidLongitude] = useState('');
  const getCentroid = () => {
    // setLoading(true);
    Api.get('gis/settings/get_titik')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setCentroidLatitude(response.data[0].latitude);
          setCentroidLongitude(response.data[0].longitude);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  return [
    {mapRef, baseLayerChange, zoomEnd, dragEnd},
    {kelurahanRefGeoJson, getKelurahan},
    {blokRefGeoJson, getBlok},
    {persilRefGeoJson, getPersil},
    {zntRefGeoJson, getZnt},
    {markerPbbRefGeoJson, getMarkerPbb},
    {markerBphtbRefGeoJson, getMarkerBphtb},
    {markerHotelRefGeoJson, getMarkerHotel},
    {markerRestoranRefGeoJson, getMarkerRestoran},
    {markerHiburanRefGeoJson, getMarkerHiburan},
    {markerReklameRefGeoJson, getMarkerReklame},
    {markerPpjRefGeoJson, getMarkerPpj},
    {markerParkirRefGeoJson, getMarkerParkir},
    {markerPatRefGeoJson, getMarkerPat},
    {markerWaletRefGeoJson, getMarkerWalet},
    {markerMblbRefGeoJson, getMarkerMblb},
    {markerPendataanRefGeoJson, getMarkerPendataan},
    {inputNop, setInputNop, facebookProgress, clearIcon, handleKeyPress, onClear, onSearchNop},
    {checked, handleDetails},
    {monografiKelurahan, setMonografiKelurahan, handleMonografiKelurahan},
    {detailMonografiKelurahan, setDetailMonografiKelurahan},
    {chartMonografiKelurahan, setChartMonografiKelurahan},
    {searchNop, searchSppt, piutangLoading, tahunSPPT, handleTahunSPPT, itemTahunSPPT, detailNop, detailSppt, images, streetView},
  ];
};

export default useHook;
